import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DEFAULT_TOOLBAR_HEIGHT, DEFAULT_YELLOW_LINE } from './Header/styles';

interface MainContainerProps {
  children?: JSX.Element;
}

const headerHeight = DEFAULT_YELLOW_LINE + DEFAULT_TOOLBAR_HEIGHT;

const styles = makeStyles(({ spacing }: Theme) => ({
  container: {
    height: `calc(100vh - (${spacing(8)} + ${headerHeight}px))`,
    display: 'flex',
    flex: 1,
  },
}));

export const MainContainer = ({ children }: MainContainerProps): JSX.Element => (
  <div className={styles().container}>{children}</div>
);

export default MainContainer;
